module.exports = __webpack_public_path__ + "static/media/rocket.ab41ffcd.png";